import _objectSpread2 from '../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js';
import _objectWithoutProperties from '../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js';
import '../../node_modules/core-js/modules/web.dom-collections.iterator.js';
import { useState, useEffect } from 'react';
import { block } from '../../utils/block.js';
import { useNotificationQueue } from './NotificationProvider.js';
import './Notification.scss.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ReactComponent as SvgClose } from '../../static/icons/action/close.svg.js';

const _excluded = ["message", "className", "isClosed", "id", "type"];
const b = block('notification');
const TIMEOUT = 8000;
const DISAPPEARING_ANIMATION_DURATION = 500;
const Notification = _ref => {
  let {
      message,
      className = '',
      isClosed,
      id,
      type
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const notifications = useNotificationQueue();
  const [isClosePressed, setIsClosePressed] = useState(false);
  useEffect(() => {
    const timerId = isClosed ? undefined : setTimeout(removeNotification, TIMEOUT);
    return () => {
      timerId && clearTimeout(timerId);
    };
  }, [isClosed]);
  const removeNotification = () => {
    setTimeout(() => notifications.remove(id), DISAPPEARING_ANIMATION_DURATION);
    setIsClosePressed(true);
  };
  return /*#__PURE__*/jsx("aside", _objectSpread2(_objectSpread2({
    className: b({
      type,
      closed: isClosed,
      removed: isClosePressed
    }).mix(className),
    id: id
  }, rest), {}, {
    children: /*#__PURE__*/jsxs("div", {
      className: b('message'),
      children: [message, isClosed && /*#__PURE__*/jsx(SvgClose, {
        className: b('cross'),
        tabIndex: 0,
        role: "button",
        onClick: removeNotification
      })]
    })
  }));
};

export { Notification };
